import { StandardEvents } from '@shopify/events';
const reduced = matchMedia('(prefers-reduced-motion: reduce)');
const active = new Set();
let pressed=null, revealTimer;
const headerStyle=document.createElement('style');
headerStyle.textContent=`
.header-section.vanity-cart-header-visible{position:fixed!important;top:0!important;left:0!important;right:0!important;width:100%!important;z-index:2147482000!important;transform:none!important}
.vanity-cart-header-visible #header-component{opacity:1!important;visibility:visible!important;translate:0 0!important;transform:none!important;animation:vanity-cart-header-enter .25s ease-out}
@keyframes vanity-cart-header-enter{from{transform:translateY(-100%)}to{transform:translateY(0)}}
@media(prefers-reduced-motion:reduce){.vanity-cart-header-visible #header-component{animation:none}}
`;
document.head.append(headerStyle);
function revealHeader(duration=8000){
 clearTimeout(revealTimer);
 const header=document.querySelector('#header-component');
 const section=header?.closest('.header-section');
 if(!section)return;
 section.classList.add('vanity-cart-header-visible');
 revealTimer=setTimeout(()=>section.classList.remove('vanity-cart-header-visible'),duration);
}

document.addEventListener('click',event=>{
 const button=event.target instanceof Element?event.target.closest('button'):null;
 if(!button || !event.isTrusted || !button.matches('add-to-cart-component button, button[name="add"], button[data-puppet="true"]'))return;
 pressed={button,form:button.form,rect:button.getBoundingClientRect(),time:performance.now()};
 revealHeader();
},true);
const visible = element => {
 const r=element.getBoundingClientRect();
 return r.width>0 && r.height>0 && r.bottom>0 && r.top<innerHeight;
};
document.addEventListener(StandardEvents.cartLinesUpdate,event=>{
 const source=event.target instanceof Element?event.target.closest('product-form-component'):null;
 if(!source || !event.promise)return;
 revealHeader();
 const scope=source.closest('product-card, dialog, .shopify-section') || source;
 const buttons=[...source.querySelectorAll('button[type="submit"], [ref="addToCartButton"]')];
 const recent=pressed && performance.now()-pressed.time<2500 && (pressed.form===source.querySelector('form') || pressed.button.dataset.puppet==='true')?pressed:null;
 const button=recent?.button || buttons.find(visible) || buttons[0];
 const media=[...scope.querySelectorAll('.product-media img, .product-card__image, img')].find(visible);
 const url=source.querySelector('add-to-cart-component')?.dataset.productVariantMedia || media?.currentSrc || media?.src;
 const origin=recent?.rect || button?.getBoundingClientRect();
 event.promise.then(({detail})=>{
  if(detail?.didError || detail?.source!=='product-form-component' || reduced.matches || !url || !origin || document.hidden)return;
  revealHeader(4500);
 requestAnimationFrame(()=>fly(url,origin));
 }).catch(()=>{});
});
function fly(url,origin){
 const icon=[...document.querySelectorAll('.header-actions__cart-icon')].find(visible);
 if(!icon)return;
 const target=icon.getBoundingClientRect(),size=Math.min(100,innerWidth*.22);
 const sx=Math.max(size/2,Math.min(innerWidth-size/2,origin.left+origin.width/2));
 const sy=Math.max(size/2,Math.min(innerHeight-size/2,origin.top+origin.height/2));
 const tx=target.left+target.width/2,ty=target.top+target.height/2;
 const layer=document.createElement('div');
 layer.setAttribute('aria-hidden','true');
 layer.style.cssText='position:fixed;inset:0;margin:0;padding:0;border:0;width:100vw;height:100dvh;overflow:visible;background:transparent;pointer-events:none;z-index:2147483001;';
 const photo=document.createElement('img');photo.src=url;photo.alt='';
 photo.style.cssText='position:absolute;width:'+size+'px;height:'+size+'px;object-fit:contain;background:#fff;border:1px solid #d8c3a5;border-radius:18px;box-shadow:0 8px 25px #5c412e30;left:0;top:0;pointer-events:none;';
 layer.append(photo);document.body.append(layer);
 if(layer.showPopover){layer.setAttribute('popover','manual');try{layer.showPopover();}catch(_){}}
 active.add(layer);
 const move=(x,y,s,rot)=>'translate('+(x-size/2)+'px,'+(y-size/2)+'px) scale('+s+') rotate('+rot+'deg)';
 const animation=photo.animate([
  {transform:move(sx,sy,.8,0),opacity:0,offset:0},
  {transform:move(sx,sy,1,0),opacity:1,offset:.12},
  {transform:move(sx+(tx-sx)*.48,Math.max(35,Math.min(sy,ty)-65),.7,-8),opacity:1,offset:.58},
  {transform:move(tx,ty,.12,6),opacity:0,offset:1}
 ],{duration:1000,easing:'cubic-bezier(.22,.65,.3,1)',fill:'forwards'});
 const clean=()=>{layer.remove();active.delete(layer);};
 const expiry=setTimeout(clean,1300);
 animation.finished.then(()=>{
  clearTimeout(expiry);clean();
  revealHeader(2200);
  if(!icon.isConnected || reduced.matches)return;
  icon.animate([{transform:'scale(1)',filter:'drop-shadow(0 0 0 transparent)'},{transform:'scale(1.3)',filter:'drop-shadow(0 0 11px #d5b477)'},{transform:'scale(1)',filter:'drop-shadow(0 0 0 transparent)'}],{duration:500,iterations:4,easing:'ease-in-out'});
 }).catch(()=>{clearTimeout(expiry);clean();});
}
addEventListener('pagehide',()=>{active.forEach(layer=>layer.remove());active.clear();});
